import { create } from 'zustand'
import type { GeneratedNote, ReferenceAnalysis } from '@/types'

/**
 * 文案生成进度状态
 */
export interface CopywritingProgress {
  current: number
  total: number
}

/**
 * 文案生成状态 Store
 * 管理文案生成的全局状态，支持跨页面持久化（在应用生命周期内）
 */
interface CopywritingState {
  // ========== 状态 ==========
  isGenerating: boolean
  isAnalyzing: boolean
  error: string | null
  generatedNotes: GeneratedNote[]
  referenceAnalysis: ReferenceAnalysis | null
  generationProgress: CopywritingProgress | null
  activeProjectId: string | null

  // ========== 操作 ==========
  setGenerating: (isGenerating: boolean) => void
  setAnalyzing: (isAnalyzing: boolean) => void
  setError: (error: string | null) => void
  setGeneratedNotes: (notes: GeneratedNote[]) => void
  setReferenceAnalysis: (analysis: ReferenceAnalysis | null) => void
  setGenerationProgress: (progress: CopywritingProgress | null) => void
  setActiveProject: (projectId: string | null) => void
  
  // 更新单篇笔记
  updateGeneratedNote: (id: string, updates: Partial<Pick<GeneratedNote, 'title' | 'content' | 'hashtags' | 'selected' | 'savedNoteId' | 'savedAt'>>) => void
  
  // 重置状态
  reset: () => void
  clearResults: () => void
}

const initialState = {
  isGenerating: false,
  isAnalyzing: false,
  error: null,
  generatedNotes: [],
  referenceAnalysis: null,
  generationProgress: null,
  activeProjectId: null,
}

export const useCopywritingStore = create<CopywritingState>((set) => ({
  ...initialState,

  setGenerating: (isGenerating) => set({ isGenerating }),
  setAnalyzing: (isAnalyzing) => set({ isAnalyzing }),
  setError: (error) => set({ error }),
  setGeneratedNotes: (notes) => set({ generatedNotes: notes }),
  setReferenceAnalysis: (analysis) => set({ referenceAnalysis: analysis }),
  setGenerationProgress: (progress) => set({ generationProgress: progress }),
  setActiveProject: (projectId) => set({ activeProjectId: projectId }),

  updateGeneratedNote: (id, updates) => {
    set((state) => ({
      generatedNotes: state.generatedNotes.map((note) =>
        note.id === id ? { ...note, ...updates } : note
      ),
    }))
  },

  reset: () => set(initialState),
  
  clearResults: () => set({
    generatedNotes: [],
    error: null,
    generationProgress: null,
  }),
}))



